import { useDispatch } from 'react-redux'

import type { AppDispatch } from '../store'

// https://redux-toolkit.js.org/tutorials/typescript#define-typed-hooks
const useAppDispatch = () => useDispatch<AppDispatch>()

export default useAppDispatch
